<h1>Accesibilidad</h1>

<p>
El sitio web ha sido diseñado para optimizar aquellas características de accesibilidad cognitiva siguiendo trabajos como <a href="https://www.w3.org/TR/coga-usable/">“Making content usable for people with cognitive and learning disabilities (W3C Working Draft 27 March 2020)”.</a>
</p>
<p>
Se utilizan recursos que siguen <a href="https://www.une.org/encuentra-tu-norma/busca-tu-norma/norma/?c=N0060036"> Pautas de lectura fácil</a> como las definiciones de Lectura Fácil del <a href="http://www.diccionariofacil.org/">“Diccionario fácil” </a>gracias a la colaboración con <a href="https://plenainclusionmadrid.org/">Plena Inclusión Madrid </a>, y pictogramas ofrecidos por <a href="http://www.arasaac.org/">ARASAAC</a>.
</p>
<p>
El sitio web se ha desarrollado siguiendo las <a href="https://www.w3.org/TR/WCAG21/">“Web Content Accessibility Guidelines (WCAG) 2.1 (W3C Recommendation 05 June 2018)</a>” en su nivel AA.
</p>
<p>
Si tienes alguna consulta, sugerencia o has detectado algún problema de accesibilidad, te agradeceríamos que contactes con nosotros en esta dirección <a href="mailto:lmoreno@inf.uc3m.es">lmoreno@inf.uc3m.es.</a> Muchas gracias.
</p>